import { UserRole } from "@/types/__generated__/union-types"

export const getAvatarColorByRole = (role?: UserRole | null): string => {
  let color = ""

  switch (role) {
    case "CALL_CENTER_AGENT":
      color = "bg-avatar-call-center-agent-surface text-on-avatar-call-center-agent-surface"
      break
    case "MEDICAL_SUPERVISOR":
      color = "bg-avatar-medical-supervisor-surface text-on-avatar-medical-supervisor-surface"
      break
    case "CUSTOMER_SERVICE_CENTER":
      color = "bg-avatar-customer-service-center-surface text-on-avatar-customer-service-center-surface"
      break
    case "NURSING_PROFESSIONAL":
      color = "bg-avatar-nursing-professional-surface text-on-avatar-nursing-professional-surface"
      break

    case "DOCTOR":
    case "NONE":
    case "SOFIA_ADMIN":
    case "SOFIA_ADMIN_TECHNICAL_ADMIN":
    case "SOFIA_ADMIN_BUSINESS_ADMIN":
    case "SOFIA_ADMIN_BUSINESS_EDITOR":
    case "SOFIA_ADMIN_MEDICAL_ADMIN":
    case "SOFIA_ADMIN_AI_ADMIN":
    case undefined:
    case null:
      color = "bg-avatar-default-surface text-on-avatar-default-surface"
      break
  }

  return color
}

export const getRoleName = (role: UserRole): string => {
  return `common.roleNames.${role}`
}
